import { useTranslation } from "react-i18next";
import InputField from "../../components/shared/InputField";
import MultiSelect from "../../components/shared/MultiSelect";
import NormalButton from "../../components/shared/NormalButton";
import PageHeader from "../../components/shared/PageHeader";
import MainContent from "../../containers/shared/MainContent";
import NormalFormContainer from "../../containers/shared/NormalFormContainer";
import PageMain from "../../containers/shared/PageMain";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import apiClient from "../../components/utils/apiClient";
import ModalContainer from "../../containers/shared/ModalContainer";

const InventoryEditPage = () => {


    const { id } = useParams();
    const { InventoryCategoriesOptions } = useContext(UserContext);
    const {t,i18n} = useTranslation();
    useDocumentTitle('تعديل مخزون');
    const navigate = useNavigate();
    const pageTitle = {title: 'تعديل مخزون', subTitle: 'يمكنك تعديل مخزون من هنا.'};
    const EmptyEditInventoryForm = {
        itemName: "",
        itemCode: "",
        category: "",
        storageLocation: "",
        quantity: "",
        issuedQuantity: "",
        reorderPoint : "",
        supplierInfo: ""
    };
    const [editInventoryForm,setEditInventoryForm] = useState(EmptyEditInventoryForm);
    const [errors, setErrors] = useState(null);
    const [isEditInventoryFormDisabled, setIsEditInventoryFormDisabled] = useState(true);

    const [deleteInventoryModal, setDeleteInventoryModal] = useState(false);


    useEffect(()=>{
        if(id) {
            getInventory();
        }
    },[id]);


    const getInventory = async () => {
        try {
          const response = await apiClient.get(`/b-inventory/${id}`);
          if(response?.data) {
            let data = response?.data;
            setEditInventoryForm(data);
          } else {
  
          }
        } catch(err) {}
      }

    const handleSubmitEditInventory = async () => {
        setIsEditInventoryFormDisabled(true);
        const finalEditInventoryForm = JSON.parse(JSON.stringify(editInventoryForm));
        finalEditInventoryForm.quantity = parseInt(finalEditInventoryForm.quantity);
        finalEditInventoryForm.issuedQuantity = parseInt(finalEditInventoryForm.issuedQuantity);
        finalEditInventoryForm.reorderPoint = parseInt(finalEditInventoryForm.reorderPoint);
        try {
        const response = await apiClient.put(`/b-inventory/${id}`,finalEditInventoryForm);
        if(response?.data) {
            navigate(`/ar/inventory`);
        } else {
            setIsEditInventoryFormDisabled(false);
        }
        } catch(err) {
            setIsEditInventoryFormDisabled(false);
            if(err?.response?.data?.errors) {
                let errorsList = {};
                err?.response?.data?.errors?.map(err=>{
                    errorsList[err.field] = err.message; 
                });
                setErrors(errorsList);
            }
        }
    }

    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }

    useEffect(()=>{
        if(editInventoryForm 
            && editInventoryForm?.itemName && editInventoryForm?.itemName !== ''
            && editInventoryForm?.itemCode && editInventoryForm?.itemCode !== ''
            && editInventoryForm?.category && editInventoryForm?.category !== ''
            && editInventoryForm?.storageLocation && editInventoryForm?.storageLocation !== ''
            && editInventoryForm?.quantity && editInventoryForm?.quantity !== ''
            && editInventoryForm?.issuedQuantity && editInventoryForm?.issuedQuantity !== ''
            && editInventoryForm?.reorderPoint && editInventoryForm?.reorderPoint !== ''
            && editInventoryForm?.supplierInfo && editInventoryForm?.supplierInfo !== '') {
            setIsEditInventoryFormDisabled(false);
        } else {
            setIsEditInventoryFormDisabled(true);
        }
    },[editInventoryForm])


    const handleSubmitDeleteInventory = () => {
        setDeleteInventoryModal(true);
    }

    const handleCloseModalDelete = () => {
        setDeleteInventoryModal(false);
    }

    const handleSubmitDeleteInventoryAction = async () => {
         try {
            const response = await apiClient.delete(`/b-inventory/${id}`);
            if(response?.data || response?.status === 204) {
                navigate(`/ar/inventory`);
            } else {
                setIsEditInventoryFormDisabled(false);
            }
        } catch(err) {setIsEditInventoryFormDisabled(false);}
    }

    return (
        <div>
        <PageHeader pageTitle={pageTitle} />
        <PageMain>
            <span className="fixed top-0 left-0 right-0 bottom-0 z-[-1] bg-grey-50"></span>
            <MainContent>
                <NormalFormContainer heading="من فضلك قم بتغيير البيانات التالية لتعديل المخزون." label="تعديل مخزون">
                    
                    <div className="mb-[15px]">
                        <InputField label={'الاسم'} placeholder={'اكتب اسم المخزون'} value={editInventoryForm?.itemName} error={errors?.itemName} errorMessage={errors?.itemName} translateError={true} onChange={(e)=>{setEditInventoryForm({ ...editInventoryForm, itemName: e.target.value }); hideError('itemName')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'الكود'} placeholder={'اكتب كود المخزون'} value={editInventoryForm?.itemCode} error={errors?.itemCode} errorMessage={errors?.itemCode} translateError={true} onChange={(e)=>{ setEditInventoryForm({ ...editInventoryForm, itemCode: e.target.value }); hideError('itemCode')}} />
                    </div>

                    <div className="mb-[15px]">
                        <MultiSelect label={'الفئة'} placeholder={'اختر فئة المخزون'} options={InventoryCategoriesOptions} error={errors?.category} errorMessage={errors?.category} value={editInventoryForm?.category} onChange={(option)=>{setEditInventoryForm({ ...editInventoryForm, category: option?.value }); hideError('category')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'مكان التخزين'} placeholder={'اكتب مكان التخزين'} value={editInventoryForm?.storageLocation} error={errors?.storageLocation} errorMessage={errors?.storageLocation} translateError={true} onChange={(e)=>{ setEditInventoryForm({ ...editInventoryForm, storageLocation: e.target.value }); hideError('storageLocation')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'الكمية الكلية'} placeholder={'اكتب الكمية الكلية'} value={editInventoryForm?.quantity} error={errors?.quantity} errorMessage={errors?.quantity} translateError={true} onChange={(e)=>{  if(e.target.value === '' || e.target.value === '0' || /^\d*[1-9]\d*$/.test(e.target.value)) { setEditInventoryForm({ ...editInventoryForm, quantity: e.target.value }) }; hideError('quantity')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'الكمية المستخدمة'} placeholder={'اكتب الكمية المستخدمة'} value={editInventoryForm?.issuedQuantity} error={errors?.issuedQuantity} errorMessage={errors?.issuedQuantity} translateError={true} onChange={(e)=>{  if(e.target.value === '' || e.target.value === '0' || /^\d*[1-9]\d*$/.test(e.target.value)) { setEditInventoryForm({ ...editInventoryForm, issuedQuantity: e.target.value }) }; hideError('issuedQuantity')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'أقل عدد مخزون لإعادة الطلب'} placeholder={'اكتب عدد أقل عدد مخزون لإعادة الطلب'} value={editInventoryForm?.reorderPoint} error={errors?.reorderPoint} errorMessage={errors?.reorderPoint} translateError={true} onChange={(e)=>{ if(e.target.value === '' || e.target.value === '0' || /^\d*[1-9]\d*$/.test(e.target.value)) { setEditInventoryForm({ ...editInventoryForm, reorderPoint: e.target.value }) }; hideError('reorderPoint')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField label={'معلومات المورد'} placeholder={'اكتب معلومات المورد'} value={editInventoryForm?.supplierInfo} error={errors?.supplierInfo} errorMessage={errors?.supplierInfo} translateError={true} onChange={(e)=>{setEditInventoryForm({ ...editInventoryForm, supplierInfo: e.target.value }); hideError('supplierInfo')}} />
                    </div>

                    <div className="text-end">
                        <NormalButton color={'!bg-danger'} label={'حذف المخزون'} onClick={handleSubmitDeleteInventory} isDisabled={false} gabEnd={true} />
                        <NormalButton label={'تعديل المخزون'} onClick={handleSubmitEditInventory} isDisabled={isEditInventoryFormDisabled} />
                    </div>

                </NormalFormContainer>
                <br />
            </MainContent>
        </PageMain>



        { deleteInventoryModal && <ModalContainer heading="حذف مخزون" handleCloseModal={handleCloseModalDelete}>
            <p className="text-[16px] text-grey-900 leading-[24px] font-[400]">هل أنت متأكد من حذف المخزون؟</p>
            <div className="text-end">
                <div className="text-grey-400 text-[18px] font-[600] inline-block cursor-pointer select-none me-[50px]" onClick={handleCloseModalDelete}>إلغاء</div>
                <NormalButton color={'!bg-danger'} label={'حذف المخزون'} onClick={handleSubmitDeleteInventoryAction} isDisabled={isEditInventoryFormDisabled} />
            </div>
        </ModalContainer> }


        </div>
    )

}

export default InventoryEditPage;